import script from "./AnalyticsByProvince.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsByProvince.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsByProvince.vue?vue&type=style&index=0&id=0f165ed4&lang=css"

const __exports__ = script;

export default __exports__